/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { cx } from "@panda/css";
import { VStack } from "@panda/jsx";

import { OrionCard } from "./OrionCard.molecule";

import type { OrionCardsSectionFragment } from "@cosmos/hygraph-schema";

export type OrionCardsProps = {
	cards: OrionCardsSectionFragment["cards"];
};

/**
 * The card column. Always a vertical stack — the responsive flip in this section is the SECTION's
 * two-column/stacked switch (OrionCards.section.tsx) and each CARD's icon-beside/icon-above switch
 * (OrionCard.molecule.tsx); the list itself never changes direction.
 */
export function OrionCards({ cards }: OrionCardsProps): React.JSX.Element {
	return (
		<VStack className={cx("orion-cards")} alignItems="stretch" gap="eds.dimension.16" minWidth="0">
			{cards.map((card, i) => (
				<OrionCard key={card.id || `orion-card-${i}`} {...card} />
			))}
		</VStack>
	);
}
